import { useSensors, useSensor, PointerSensor, KeyboardSensor, TouchSensor } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

/**
 * Custom hook for drag-and-drop sensors and configuration
 */
export function useDragDrop() {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        // distance-only: tolerance is for delay-based constraints. With both set
        // equal here, the tolerance check fired first and cancelled drag at the
        // same 5px threshold before activation could trigger (6313e864).
        distance: 5,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 150, // Small delay to distinguish from scroll
        tolerance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return { sensors };
}
